import { REPLACE_ORDER_TABLET_GENERATED_ID_WS } from './chunk-5J2PASRY.mjs';
import { SET_IS_BOTTOM_SHEET_OPEN, SET_LAST_SERVICE_AREAS_ORDER, REMOVE_SERVICE_AREA, UPDATE_SERVICE_AREAS, UPDATE_SERVICE_AREA, SET_NEW_SERVICE_AREA, SET_LAST_REDO_CHANGES, SET_LAST_UNDO_CHANGES, UPDATE_TABLE_LAYOUT_STORE, UPDATE_SINGLE_TABLE_TABLE_LAYOUT_STATE, UPDATE_SINGLE_TABLE_WS, UPDATE_TABLES_WS, UPDATE_TABLES, SET_TOOL_SETTINGS, SET_SELECTED_LAYOUT, SET_ORDER_TYPE, SET_SERVICE_AREA, INITIALIZE_LAYOUT, INITIALIZE_TABLES_LAYOUT, SET_SELECTED_ACTION, SET_SELECTED_TABLES, SET_SELECTED_ELEMENT, SET_LAST_LAYOUT_CHANGE_TO_CURRENT_EDIT_DATA, DISCARD_TABLE_LAYOUT_CHANGES, RESET_CURRENT_EDIT_DATA, SET_CURRENT_EDIT_DATA, UPDATE_TABLE_LAYOUT_AND_ORDERS, SET_SAVE_LAYOUT_CHANGES, SET_TABLE_LAYOUT_DATA } from './chunk-VZEH4VMY.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import cloneDeep from 'lodash/cloneDeep';

var REVENUE_CENTERS_INITIAL_STATE = {};
var SERVICE_AREAS_INITIAL_STATE = {};
var TABLE_LAYOUTS_INITIAL_STATE_TEST = {};
var TOOL_SETTINGS_INITIAL_STATE = {
  gridWidth: 1500,
  gridHeight: 700,
  smallUnitSize: 10,
  bigUnitSize: 100,
  showGrid: true,
  showSmallUnits: true,
  showBigUnits: true
};
var TABLE_LAYOUT_INITIAL_STATE = {
  savedData: {
    revenueCenters: REVENUE_CENTERS_INITIAL_STATE,
    serviceAreas: SERVICE_AREAS_INITIAL_STATE,
    serviceAreaLayouts: TABLE_LAYOUTS_INITIAL_STATE_TEST,
    tables: {}
  },
  currentEditData: {
    revenueCenters: REVENUE_CENTERS_INITIAL_STATE,
    serviceAreas: SERVICE_AREAS_INITIAL_STATE,
    serviceAreaLayouts: TABLE_LAYOUTS_INITIAL_STATE_TEST,
    tables: {}
  },
  currentEditLayout: {
    selectedElement: null,
    selectedServiceArea: null,
    selectedOrderType: null,
    lastServiceAreasOrder: null,
    undoList: [],
    redoList: [],
    selectedLayout: null
  },
  selectedTables: [],
  selectedAction: null,
  toolSettings: TOOL_SETTINGS_INITIAL_STATE,
  isBottomSheetOpen: false
};
var tableLayoutReducer = (state = TABLE_LAYOUT_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_TABLE_LAYOUT_DATA:
      return __spreadProps(__spreadValues({}, state), {
        savedData: action.payload
      });
    case SET_SAVE_LAYOUT_CHANGES:
      return __spreadProps(__spreadValues({}, state), {
        savedData: __spreadValues({}, action.payload)
      });
    case UPDATE_TABLE_LAYOUT_AND_ORDERS:
      return __spreadProps(__spreadValues({}, state), {
        savedData: __spreadValues(__spreadValues({}, state.savedData), action.payload.tableLayout)
      });
    case SET_CURRENT_EDIT_DATA:
      return __spreadProps(__spreadValues({}, state), {
        currentEditData: cloneDeep(state.savedData)
      });
    case RESET_CURRENT_EDIT_DATA:
      return __spreadProps(__spreadValues({}, state), {
        currentEditData: cloneDeep(TABLE_LAYOUT_INITIAL_STATE.currentEditData),
        currentEditLayout: cloneDeep(
          TABLE_LAYOUT_INITIAL_STATE.currentEditLayout
        )
      });
    case DISCARD_TABLE_LAYOUT_CHANGES:
      return __spreadProps(__spreadValues({}, state), {
        currentEditData: cloneDeep(state.savedData),
        currentEditLayout: __spreadValues(__spreadProps(__spreadValues({}, state.currentEditLayout), {
          selectedElement: null,
          lastServiceAreasOrder: null,
          undoList: [],
          redoList: []
        }), action.payload.resetToDefault ? {
          selectedServiceArea: null,
          selectedLayout: null
        } : {})
      });
    case SET_LAST_LAYOUT_CHANGE_TO_CURRENT_EDIT_DATA:
      return __spreadProps(__spreadValues({}, state), {
        currentEditData: __spreadProps(__spreadValues({}, state.currentEditData), {
          serviceAreaLayouts: action.payload
        })
      });
    case SET_SELECTED_ELEMENT:
      return __spreadProps(__spreadValues({}, state), {
        currentEditLayout: __spreadProps(__spreadValues({}, state.currentEditLayout), {
          selectedElement: action.payload ? {
            id: action.payload.id,
            type: action.payload.type,
            showControls: action.payload.showControls
          } : null
        })
      });
    case SET_SELECTED_TABLES:
      return __spreadProps(__spreadValues({}, state), {
        selectedTables: [...action.payload]
      });
    case SET_SELECTED_ACTION:
      return __spreadProps(__spreadValues({}, state), {
        selectedAction: action.payload === state.selectedAction ? null : action.payload
      });
    case INITIALIZE_TABLES_LAYOUT:
      return __spreadProps(__spreadValues({}, state), {
        selectedTables: [],
        selectedAction: null
      });
    case INITIALIZE_LAYOUT:
      return __spreadProps(__spreadValues({}, state), {
        currentEditData: cloneDeep(state.savedData),
        currentEditLayout: {
          undoList: [],
          redoList: [],
          selectedServiceArea: null,
          selectedOrderType: null,
          selectedElement: null,
          lastServiceAreasOrder: null,
          selectedLayout: null
        }
      });
    case SET_SERVICE_AREA:
      return __spreadProps(__spreadValues({}, state), {
        currentEditLayout: __spreadProps(__spreadValues({}, state.currentEditLayout), {
          selectedServiceArea: action.payload
        })
      });
    case SET_ORDER_TYPE:
      return __spreadProps(__spreadValues({}, state), {
        currentEditLayout: __spreadProps(__spreadValues({}, state.currentEditLayout), {
          selectedOrderType: action.payload
        })
      });
    case SET_SELECTED_LAYOUT:
      return __spreadProps(__spreadValues({}, state), {
        currentEditLayout: __spreadProps(__spreadValues({}, state.currentEditLayout), {
          selectedLayout: action.payload
        })
      });
    case SET_TOOL_SETTINGS:
      return __spreadProps(__spreadValues({}, state), {
        toolSettings: action.payload
      });
    case UPDATE_TABLES:
    case UPDATE_TABLES_WS:
      return __spreadProps(__spreadValues({}, state), {
        savedData: __spreadProps(__spreadValues({}, state.savedData), {
          tables: __spreadValues({}, action.payload)
        })
      });
    case UPDATE_SINGLE_TABLE_WS: {
      const tableId = action.payload.id;
      return __spreadProps(__spreadValues({}, state), {
        savedData: __spreadProps(__spreadValues({}, state.savedData), {
          tables: __spreadProps(__spreadValues({}, state.savedData.tables), {
            [tableId]: __spreadValues(__spreadValues({}, state.savedData.tables[tableId]), action.payload)
          })
        })
      });
    }
    case UPDATE_SINGLE_TABLE_TABLE_LAYOUT_STATE:
      return __spreadProps(__spreadValues({}, state), {
        savedData: __spreadProps(__spreadValues({}, state.savedData), {
          tables: __spreadProps(__spreadValues({}, state.savedData.tables), {
            [action.payload.tableId]: __spreadValues(__spreadValues({}, state.savedData.tables[action.payload.tableId]), action.payload.table)
          })
        })
      });
    case UPDATE_TABLE_LAYOUT_STORE:
      return __spreadValues(__spreadValues({}, state), action.payload);
    case SET_LAST_UNDO_CHANGES:
      return __spreadProps(__spreadValues({}, state), {
        currentEditLayout: __spreadProps(__spreadValues({}, state.currentEditLayout), {
          undoList: [...action.payload]
        })
      });
    case SET_LAST_REDO_CHANGES:
      return __spreadProps(__spreadValues({}, state), {
        currentEditLayout: __spreadProps(__spreadValues({}, state.currentEditLayout), {
          redoList: [...action.payload]
        })
      });
    case SET_NEW_SERVICE_AREA:
      return __spreadProps(__spreadValues({}, state), {
        currentEditData: __spreadProps(__spreadValues({}, state.currentEditData), {
          serviceAreas: __spreadValues(__spreadValues({}, state.savedData.serviceAreas), action.payload.serviceArea),
          serviceAreaLayouts: __spreadValues(__spreadValues({}, state.savedData.serviceAreaLayouts), action.payload.serviceAreaOBJ)
        })
      });
    case UPDATE_SERVICE_AREA:
      return __spreadProps(__spreadValues({}, state), {
        currentEditData: __spreadProps(__spreadValues({}, state.currentEditData), {
          serviceAreas: __spreadProps(__spreadValues({}, state.currentEditData.serviceAreas), {
            [action.payload.serviceAreaId]: action.payload.serviceArea
          })
        })
      });
    case UPDATE_SERVICE_AREAS:
      return __spreadProps(__spreadValues({}, state), {
        currentEditData: __spreadProps(__spreadValues({}, state.currentEditData), {
          serviceAreas: __spreadValues({}, action.payload)
        })
      });
    case REMOVE_SERVICE_AREA:
      return __spreadProps(__spreadValues({}, state), {
        currentEditData: __spreadProps(__spreadValues({}, state.currentEditData), {
          serviceAreas: action.payload.serviceAreas,
          serviceAreaLayouts: action.payload.serviceAreaLayouts
        }),
        currentEditLayout: {
          selectedElement: null,
          selectedLayout: null,
          selectedServiceArea: null,
          selectedOrderType: null,
          lastServiceAreasOrder: null,
          undoList: [],
          redoList: []
        }
      });
    case SET_LAST_SERVICE_AREAS_ORDER:
      return __spreadProps(__spreadValues({}, state), {
        currentEditLayout: __spreadProps(__spreadValues({}, state.currentEditLayout), {
          lastServiceAreasOrder: action.payload
        })
      });
    case SET_IS_BOTTOM_SHEET_OPEN:
      return __spreadProps(__spreadValues({}, state), {
        isBottomSheetOpen: action.payload
      });
    case REPLACE_ORDER_TABLET_GENERATED_ID_WS: {
      if (!action.payload.tableId)
        return state;
      return __spreadProps(__spreadValues({}, state), {
        savedData: __spreadProps(__spreadValues({}, state.savedData), {
          tables: __spreadProps(__spreadValues({}, state.savedData.tables), {
            [action.payload.tableId]: __spreadProps(__spreadValues({}, state.savedData.tables[action.payload.tableId]), {
              orderId: action.payload.orderId
            })
          })
        })
      });
    }
    default:
      return state;
  }
};
var reducers_default = tableLayoutReducer;

export { reducers_default };
